/**
 * The CategoryList component displays a list of categories and allows the user to view more
 * categories.
 * @returns The CategoryList component is being returned, which displays a list of categories and a
 * "View More" button that links to the /categories page. The categories are obtained from the Redux
 * store using the useSelector hook and are sliced to display only the first 17 categories. The
 * CategoryItems component is used to display each individual category.
 */
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import "../categoryList/categorylist.css";
import CategoryItems from "./CategoryItems";

const CategoryList = () => {
  const categories = useSelector((state) => state.categories);
  const displayedCategories = categories.slice(0, 18);
  return (
    <>
      <div className="container">
        <div id="categories_homepage">
          <h2 id="categories_title_homepage">Categories</h2>
          <Link to="/categories">
            <h2 id="see_all_homepage">See All</h2>
          </Link>
        </div>

        <div className="categoryListContainer">
          {displayedCategories.map((categoryObj) => (
            <CategoryItems
              key={categoryObj.categoryId}
              categoryObj={categoryObj}
            />
          ))}
          {/* {categories.length > 12 && (
            <Link
              className="categoryListBox categoryListViewMoreBox d-flex justify-content-center align-items-center flex-column"
              to="/categories"
              title="View More Categories"
            >
              <i className="material-icons fs-4 mb-1">widgets</i>
              View Moreeee
            </Link>
          )} */}
        </div>
      </div>
    </>
  );
};

export default CategoryList;
